const styles = (theme, height) => {
    return {
        '& .p-datatable-scrollable-header': {
            background: 'none',
            [theme.darkTheme]: {
                borderBottom: 'solid 1px #222',
                color: '#000'
            }
        },
        '& .p-datatable-row:nth-of-type(2n+1)': {
            borderTop: '1px solid #dddddd',
            borderBottom: '1px solid #dddddd',
            [theme.darkTheme]: {
                borderTop: '1px solid ' + theme.dark.primary,
                borderBottom: '1px solid ' + theme.dark.primary
            }
        },
        '& .p-datatable-row:nth-of-type(2n)': {
            borderTop: '1px solid #dddddd',
            borderBottom: '1px solid #dddddd',
            [theme.darkTheme]: {
                borderTop: '1px solid ' + theme.dark.primary,
                borderBottom: '1px solid ' + theme.dark.primary
            }
        },
        '& .p-datatable-scrollable-wrapper': {
            borderRadius: '4px',
            overflow: 'hidden',
            borderTop: 'solid 1px #dddddd',
            borderLeft: 'solid 1px #dddddd',
            borderRight: 'solid 1px #dddddd',
            borderBottom: 'solid 1px #dddddd',
            [theme.darkTheme]: {
                borderTop: 'solid 1px #222',
                borderLeft: 'solid 1px #222',
                borderRight: 'solid 1px #222',
                borderBottom: 'solid 1px #222'
            }
        },
        '& .p-datatable-scrollable-body': {
            height: height ? height : 'calc(100vh - 280px)'
        },
        '& .p-inputtext.p-component.p-column-filter': {
            borderRadius: '4px'
        },
        '& .p-dropdown label.p-dropdown-label': {
            textOverflow: 'ellipsis',
            width: '88%'
        },
        '& .p-datatable-tbody tr td': {
            fontSize: '13px',
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-datatable-tbody tr': {
            height: 48
        },
        '& .p-datatable-thead tr': {
            height: 36,
            [theme.darkTheme]: {
                color: '#fff'
            }
        },
        '& .p-paginator': { display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', padding: '0.4em' },
        '& .p-paginator-left-content': { marginRight: 'auto' },
        '& .p-paginator-right-content': { marginLeft: 'auto' },
        '& .p-paginator-page': {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: 3,
            justifyContent: 'center',
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
            color: '#222',
            minWidth: '2.357rem',
            fontSize: '1.2rem',
            lineHeight: 2,
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-paginator-next': {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1',
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
            color: '#222',
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-paginator-last': {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1',
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
            color: '#222',
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-paginator-first': {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1',
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
            color: '#222',
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-paginator-prev': {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1',
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
            color: '#222',
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-paginator-current': {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '2',
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
            color: '#222',
            fontSize: '14px',
            [theme.darkTheme]: {
                color: '#aaa'
            }
        },
        '& .p-paginator-element-focus': { zIndex: '1', position: 'relative' },
        '& .p-paginator .p-paginator-pages .p-paginator-page.p-highlight': {
            backgroundColor: '#4a773c',
            color: '#fff'
        },
        '& .pi': {
            fontSize: '18px'
        },
        '& .checkboxDisabled  .p-checkbox .p-checkbox-box': {
            border: `1px solid ${theme.palette.grey['A200']}`,
            opacity: '0.5',
            cursor: 'default'
        }
    };
};

const GridStyles = {
    styles: styles
};

export default GridStyles;
